export default __webpack_public_path__ + "d12.png";